(() => {
  const key = 'filter.v.availability';
  const isListing = () => /^\/collections\/[^/]+\/?$/.test(location.pathname) || location.pathname === '/search';
  const current = () => new URL(location.href);
  function ensureDefault() {
    const url = current();
    const values = url.searchParams.getAll(key);
    document.documentElement.dataset.dripIncludeSoldOut = values.includes('0') ? 'true' : 'false';
    if (isListing() && !values.length) {
      url.searchParams.set(key, '1');
      url.searchParams.delete('page');
      location.replace(url.href);
      return false;
    }
    return true;
  }
  if (!ensureDefault()) return;
  function sync() {
    if (!ensureDefault() || !isListing()) return;
    const list = document.querySelector('results-list');
    if (!list) return;
    let box = list.querySelector('[data-drip-stock-toggle]');
    if (!box) {
      box = document.createElement('label');
      box.dataset.dripStockToggle = 'true';
      box.className = 'drip-stock-toggle';
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.addEventListener('change', () => {
        const url = current();
        url.searchParams.delete(key);
        url.searchParams.append(key, '1');
        if (input.checked) url.searchParams.append(key, '0');
        url.searchParams.delete('page');
        location.assign(url.href);
      });
      box.append(input, document.createTextNode(' Include out of stock'));
      list.prepend(box);
    }
    box.querySelector('input').checked = current().searchParams.getAll(key).includes('0');
  }
  function start() {
    sync();
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; sync(); });
    }).observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true});
    window.addEventListener('popstate', sync);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();